






















import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { Toast } from 'vant'; 
import { dialogPanel } from '@/components';
@Component({
    components: {dialogPanel},
}) 
export default class selectLabelPaper extends Vue {
   
    public $refs!: {
       
    };
    show = false;

    defaultList=[
        {
            name:'40mm*30mm',
            tip:'常规标签纸，适用于大多数商品',
            onlyOld:true,
            value:1,
        },
        {
            name:'40mm*60mm',
            tip:'大规格标签纸，适用于打印更多的商品信息',
            onlyOld:true,
            value:2,
        },
        {
            name:'30mm*20mm',
            tip:'中号标签纸，适用于打印精简的商品信息',
            onlyOld:false,
            value:4,
        },
        {
            name:'25mm*15mm',
            tip:'小号标签纸，适用于粘贴在挂件、配饰上',
            onlyOld:false,
            value:5,
        },
        {
            name:'15mm*25mm-双面挂签',
            tip:'珠宝标签竖版，总长76mm，正反两面打印，可穿挂在珠宝、首饰上',
            onlyOld:false,
            value:3,
        },
        {
            name:'30mm*15mm-双面挂签',
            tip:'珠宝标签纸横版，总长75mm，正反两面打印，可穿挂在珠宝、首饰上',
            onlyOld:false,
            value:6,
        },
    ]
    list = [];
    pageSize=1;


    async mounted() {
        
    }
    async created() {
    
    }

    closeFun(){
        this.show = false;
    }
    showFun(val,isOnlyOld){
        this.pageSize = val;
        if(isOnlyOld){
            this.list = this.defaultList.filter(v=>v.onlyOld); 
        }else{
            this.list = this.defaultList; 
        }
        this.show = true;
    }

}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/setting/components/selectLabelPaper.vue